import { useMemo, useState } from "react";
import { Wand2, BarChart3 } from "lucide-react";
import { useTheme } from "../../../shared/common/ThemeContext";
import PlanningMicrocycleLab from "./PlanningMicrocycleLab";
import ResultsInsightsTab from "../components/prediction/ResultsInsightsTab";
import { useTranslation } from "react-i18next";

export default function SimulationPage() {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const [tab, setTab] = useState("planning");

  const shell = isDarkMode ? "bg-gray-900 text-gray-100" : "bg-gray-100 text-gray-900";
  const muted = isDarkMode ? "text-gray-400" : "text-gray-600";

  const tabs = useMemo(
    () => [
      { id: "planning", label: t("pages.simulation.tab_planning"), icon: Wand2 },
      { id: "results", label: t("pages.simulation.tab_results"), icon: BarChart3 },
    ],
    [t]
  );

  const tabBtn = (active) =>
    `inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-medium border transition
     ${
       active
         ? "bg-emerald-600 text-white border-emerald-600 shadow-sm"
         : isDarkMode
         ? "bg-gray-800 border-gray-700 text-gray-300 hover:bg-gray-750"
         : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
     }`;

  return (
    <div className={`${shell} min-h-screen p-6`}>
      <div className="mx-auto max-w-7xl">
        <div className="mb-5">
            <h1 className="text-3xl font-bold">{t("pages.simulation.title")}</h1>
          <p className={`${muted} mt-1`}>
            {t("pages.simulation.subtitle")}
          </p>
        </div>

        <div className="mb-6 flex flex-wrap gap-2">
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <button key={t.id} className={tabBtn(tab === t.id)} onClick={() => setTab(t.id)}>
                <Icon size={16} />
                {t.label}
              </button>
            );
          })}
        </div>

        {tab === "planning" ? (
            <PlanningMicrocycleLab />
        ) : (
            <ResultsInsightsTab />
        )}
      </div>
    </div>
  );
}
